import React, { useCallback, useContext, useEffect, useState } from 'react'
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import Menu from '../../components/Menu';
import axios from 'axios';
import { LoadingContext } from '../../context/LoadingContext';
import ReactLoader from '../../components/ReactLoader';
import Swal from 'sweetalert2';
const config = require('../../config.json')


export default function ProductReBuy({ ipAddress, loginData }) {
    const [info, setInfo] = useState({});
    const [loading, setLoading] = useContext(LoadingContext)
    const [cart, setCart] = useState([]);
    const addToCart = (product) => {
        const existingProduct = cart.find((item) => item.id === product.id);
        if (existingProduct) {
            setCart(
                cart.map((item) =>
                    item.id === product.id
                        ? { ...item, quantity: item.quantity + 1 }
                        : item
                )
            );
        } else {
            setCart([...cart, { ...product, quantity: 1 }]);
        }
        Swal.fire({
            icon: 'success',
            title: 'Product added to cart',
            showConfirmButton: false,
            timer: 1500
        })
    };

    const removeFromCart = (productId) => {
        Swal.fire({
            icon: 'question',
            title: 'Do You Want To remove this product from cart?',
            showConfirmButton: true,
            showCancelButton: true,
        }).then((result) => {
            if (result.isConfirmed) {
                setCart(cart.filter((item) => item.id !== productId));
            }
        })
    }

    const updateQuantity = (productId, quantity) => {

        if (quantity < 1) {
            removeFromCart(productId);
        } else {
            setCart(
                cart.map((item) =>
                    item.id === productId ? { ...item, quantity } : item
                )
            );
        }
    }
    const emptyCart = () => {
        setCart([]);
    }



    const totalMRP = cart.reduce((acc, item) => acc + item.product_mrp * item.quantity, 0);

    // Generate an array of productId and quantity for server
    const cartDetails = cart.map((item) => ({
        productId: item.id,
        quantity: item.quantity,
    }));

    const handleInfo = useCallback(() => {
        setLoading(true)
        let data = JSON.stringify({
            "ip": ipAddress,
            "ulid": loginData.ulid
        });

        let axiosConfig = {
            method: 'post',
            maxBodyLength: Infinity,
            url: `${config.baseUrl}products`,
            headers: {
                'ip': ipAddress,
                'ulid': loginData.ulid,
                'auth': loginData.auth,
                'token': loginData.token,
                'Content-Type': 'application/json'
            },
            data: data
        };
        // console.log(axiosConfig)
        axios.request(axiosConfig)
            .then((response) => {
                console.log(response.data)
                setInfo(response.data)
                setLoading(false)
            })
            .catch((error) => {
                console.log(error);
            });
    }, [ipAddress, loginData.auth, loginData.token, loginData.ulid, setLoading])

    const handleCheckout = () => {
        if (info?.balance?.rep >= totalMRP) {
            if (totalMRP > 0) {
                if (cart.length > 0) {
                    setLoading(true)
                    let data = JSON.stringify({
                        "ip": ipAddress,
                        "ulid": loginData.ulid.Cart,
                        "totalMrp": totalMRP,
                        "cartDetails": cartDetails
                    });
                    let axiosConfig = {
                        method: 'post',
                        maxBodyLength: Infinity,
                        url: `${config.baseUrl}productrebuy`,
                        headers: {
                            'ip': ipAddress,
                            'ulid': loginData.ulid,
                            'auth': loginData.auth,
                            'token': loginData.token,
                            'Content-Type': 'application/json'
                        },
                        data: data
                    };
                    // console.log(axiosConfig)
                    axios.request(axiosConfig)
                        .then((response) => {
                            setLoading(false)
                            Swal.fire({
                                icon: 'success',
                                title: 'AD Herbal',
                                text: response.data?.message
                            })
                            emptyCart()
                            handleInfo()
                            console.log(response.data)
                        })
                        .catch((error) => {
                            console.log(error);
                        });
                }
            }
        }
    }

    useEffect(() => {
        handleInfo()
    }, [handleInfo])

    return (
        <>
            <div className="layout-container">
                <Menu />
                <div className="layout-page">
                    <Header />
                    {loading ? <><ReactLoader /></> :
                        <div className="content-wrapper mb-4">
                            <div className="container-xxl flex-grow-1 container-p-y pt-2">
                                <div>
                                    <div className='row'>
                                        <div className="col-md-12  mb-2">
                                            <div className="card">
                                                <div className="card-header align-items-center ">
                                                    <div className="card-title mb-0">
                                                        <h6 className="m-0 text-center text-black ">Products Buy From Repurchase</h6>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='row'>
                                        <div className="col-lg-4 col-md-6 col-sm-6 mb-2" key="n2">
                                            <div className="card">
                                                <div className="card-body dashinc">
                                                    <div className="d-flex justify-content-between">
                                                        <div className="card-info">
                                                            <p className="card-text m-0 text-black text-sm">Repurchase Wallet Balance </p>
                                                            <div className="d-flex align-items-end mb-2">
                                                                <small className="text-black "><i className='bx bx-rupee bx-xs'></i>  {info?.balance?.rep}  </small>
                                                            </div>
                                                        </div>
                                                        <div className="card-icon">
                                                            <span className="badge bg-label-success rounded p-2">
                                                                <i className='bx bx-rupee bx-sm'></i>
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='row '>
                                        <div className='col-md-12  mb-2 '>
                                            <div className="card mb-2">
                                                <div className="card-header d-flex align-items-center justify-content-between p-1">
                                                    <div className="table-responsive">
                                                        <table className="table table-borderless">
                                                            <tbody>
                                                                {
                                                                    cart.length > 0 ? cart.map((list, index) => {

                                                                        return (
                                                                            <>
                                                                                <tr key={index + 101} style={{ borderTop: '1px solid black' }}>
                                                                                    <td>
                                                                                        <div className="d-flex justify-content-start align-items-center">
                                                                                            <div className="avatar me-1">
                                                                                                <img src={list?.link} alt="Avatar" className="rounded-circle" height={"50px"} />
                                                                                            </div>
                                                                                            <div className="d-flex flex-column">
                                                                                                <h6 className="mb-0 text-sm text-black">{list?.product_name}</h6>
                                                                                            </div>
                                                                                        </div>
                                                                                    </td>
                                                                                    <td><span className='text-sm text-black'>MRP:{list.product_mrp * list.quantity}</span></td>

                                                                                    <td><span className='text-sm text-black'>Quantity:{list.quantity}</span></td>
                                                                                    <td><button className='btn btn-xs btn-danger' onClick={() => removeFromCart(list.id, list.quantity)}>X</button></td>

                                                                                </tr>
                                                                            </>
                                                                        )
                                                                    }) : <tr><td className='text-sm'>NO PRODUCT IN CART</td></tr>}
                                                            </tbody>
                                                            <tfoot>
                                                                <tr>
                                                                    <th className='text-sm'>
                                                                        Total MRP :
                                                                    </th >
                                                                    <th>{totalMRP}</th>
                                                                    <th className='text-sm'>
                                                                        Balance
                                                                    </th>
                                                                    <th>{info?.balance?.rep}</th>
                                                                </tr>
                                                            </tfoot>
                                                        </table>
                                                    </div>
                                                </div>
                                                <div className="card mt-2">
                                                    <div className="card-header">
                                                        <div className='row'>
                                                            <div className='col-md-12 text-center'>
                                                                {(info?.balance?.rep >= totalMRP) ? <button className='btn btn-info btn-sm' onClick={handleCheckout}>Checkout</button> : <button className='btn btn-danger btn-sm'>Insufficient Balance</button>}

                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='row'>
                                        {
                                            info?.info?.map((list, index) => {
                                                return (
                                                    <div className="col-lg-4 col-md-6 col-sm-6 col-6 mb-2" key={index + 1001}>
                                                        <div className="card text-center h-100">
                                                            <img className="card-img-top" src={list.link} alt={list.product_name + ' Image'} height={'100px'} width={'100%'} />
                                                            <div className="card-body m-0 p-2">
                                                                <div className='mb-1'>
                                                                    <p className="card-title m-1">{list.product_name}</p>
                                                                    <p className="card-text text-sm m-1">
                                                                        {list.product_info}
                                                                    </p>
                                                                    <p className="card-text text-sm mb-0">MRP :<i className='fa fa-inr'></i>{list?.product_mrp} </p>
                                                                </div>
                                                                <button className="btn btn-info btn-sm mb-1" onClick={() => addToCart(list)}>Add To Cart</button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )
                                            })
                                        }
                                    </div>
                                </div>
                            </div>
                            <Footer />
                        </div>}
                </div>
            </div>

        </>
    );
}